import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastrService } from 'ngx-toastr';
import { CODIGO_CENTRUS } from '../../../../app.constants';
import { DestinacaoReservaModel } from '../../../shared/models/destinacao-reserva.model';
import { PessoaDadosSimplicadosModel } from '../../../shared/models/pessoa-simplificada.model';
import { DR2009Pdf } from '../../../shared/services/documentos-pdf-imprimir/Plano/destinacao-reserva/dr2009-pdf';
import { PessoaService } from '../../../shared/services/pessoa.service';
import { DateUtilService } from '../../../shared/util/date-util.service';
import { StorafeUtil } from '../../../shared/util/storasge.util';
import { DestinacaoReservaService } from '../service/destinacao-reserva.service';
import { AuthInterceptor } from '../../../interceptor/auth.interceptor';
import { MessageUtil } from '../../../shared/messages/messageUtil';

@Component({
  selector: 'app-destinacao-reserva-2009',
  templateUrl: './destinacao-reserva-2009.component.html',
  styleUrls: ['./destinacao-reserva-2009.component.css']
})
export class DestinacaoReserva2009Component implements OnInit {
  //

  componentes: any[] = [1];

  destinacaoReservaModel: DestinacaoReservaModel = new DestinacaoReservaModel();

  destinacaoReservaList: any[] = [];

  pessoaDadosSimplicadosModel: PessoaDadosSimplicadosModel = new PessoaDadosSimplicadosModel();

  // 35165 1339180


  @BlockUI() blockUi: NgBlockUI;

  listarMesesAno: Array<any> = new Array<any>();
  mesAno = '';

  cdCentrus: number;
  cdCentrusTit: number;
  mes: number;
  ano: number;
  nrSuperavit = 2;

  descricaoMesAno = ';'
  param: string;
  mensagemSuperior: string;
  verificarDestinacaoReserva2008Compl: number;

  constructor(
    private destinacaoReservaService: DestinacaoReservaService,
    private pessoaService: PessoaService,
    private dateUtilService: DateUtilService,
    private router: Router,
    private authInterceptor: AuthInterceptor,
    private toastrService: ToastrService,
    private dR2009Pdf: DR2009Pdf
  ) { }

  ngOnInit() {

    this._gerenciarCodigoIndentificao();
  }


  getDadosSesseionStorage(): Promise<string> {

    return new Promise((resolve, reject) => {
      const recuperandoObjeto = StorafeUtil.recuperarSessionStorage(CODIGO_CENTRUS);
      resolve(recuperandoObjeto);
    })


  }


  private async _gerenciarCodigoIndentificao(): Promise<void> {
    await this.getDadosSesseionStorage()
    .then(recuperandoObjeto => {

      if (recuperandoObjeto) {
        const novoObjeto = Number(JSON.parse(recuperandoObjeto));
        this.cdCentrus = novoObjeto
        this.param = '/administrativo/operacoesConsultaParticipante';
      } else {
        this.cdCentrus = this.authInterceptor.getJwtCdCentrus();
        this.param =  '/cardMenus/cardMenuPlanos';
      }
      this.getPessoasDadosSimplificado();
      this.getListarAnos();
      })
  }


  async getPessoasDadosSimplificado() {
    try {
      this.pessoaDadosSimplicadosModel = await this.pessoaService.getPessoas(this.cdCentrus);
      this.getCdCentrusTitular();
    } catch (error) {
       this.router.navigate([this.param], { skipLocationChange: true })
        this.toastrService.info(MessageUtil.REGISTRO_NAO_ENCONTRADO, '', { timeOut: 8000 });
    }
  }

  async getCdCentrusTitular() {
    try {
      this.cdCentrusTit = await this.pessoaService.getCdCentrusTitular(this.cdCentrus);
      if (!this.cdCentrusTit) {this.cdCentrusTit = this.cdCentrus};
      this.getUltimaData();
    } catch (error) {
      console.error(error);
    }
  }

  async getUltimaData() {
    try {
      const mesAno = await this.destinacaoReservaService.getUltimaData(this.cdCentrus, this.nrSuperavit);

      if (mesAno === null) {
        this.blockUi.stop();
         this.router.navigate([this.param], { skipLocationChange: true })
        this.toastrService.info(MessageUtil.REGISTRO_NAO_ENCONTRADO);
        return;
      }

      (mesAno.mes < 10) ? (this.mesAno = (`0${mesAno.mes}/${mesAno.ano}`)) : (this.mesAno = (`${mesAno.mes}/${mesAno.ano}`))
      this.descricaoMesAno = this.dateUtilService._carregarDescricaoMesAno(mesAno.mes, mesAno.ano);
      this.getdDataReferencia(this.mesAno);
    } catch (error) {
      this.toastrService.info('Não foi encontrado destinação reserva para essa data', 'Não foi encontrado', { timeOut: 8000 })
    }
  }

  async getListarAnos() {
    try {
      const mesesAnosList = await this.destinacaoReservaService.getListarAnos(this.cdCentrus, this.nrSuperavit);
      this.listarMesesAno = new Array<any>();
      this.listarMesesAno.push({ label: 'Selecione uma opção', value: '' })
      mesesAnosList.map(item => this.listarMesesAno.push({ label: item, value: item }));
    } catch (error) {
      console.error(error);
    }
  }

  getdDataReferencia(periodoEscolhido) {
    this.mes = Number(periodoEscolhido.split('/')[0]);
    this.ano = Number(periodoEscolhido.split('/')[1]);
    this.getObterDestinacaoReserva();
    this.descricaoMesAno = this.dateUtilService._carregarDescricaoMesAno(this.mes, this.ano);

  }

  async getVerificarDestinacaoReserva() {
    try {
      const verificarDestinacaoReserva = await this.destinacaoReservaService.getVerificarDestinacaoReserva(this.cdCentrus, this.cdCentrusTit, this.mes, this.ano, this.nrSuperavit);

      if (verificarDestinacaoReserva === null) {
        this.blockUi.stop();
         this.router.navigate([this.param], { skipLocationChange: true })
        this.toastrService.info(MessageUtil.REGISTRO_NAO_ENCONTRADO);
        return;
      }

      if (verificarDestinacaoReserva) {
        this.getObterDestinacaoReserva();
      }

    } catch (error) {
       this.router.navigate([this.param], { skipLocationChange: true })
      this.toastrService.error(MessageUtil.REGISTRO_NAO_ENCONTRADO, '', {timeOut: 8000});
    }
  }



  async getObterDestinacaoReserva() {
    try {
      const destinacaoReservaModel = await this.destinacaoReservaService.getObterDestinacaoReserva(this.cdCentrus, this.cdCentrusTit, this.mes, this.ano, this.nrSuperavit);

      if (destinacaoReservaModel === null) {
        this.blockUi.stop();
         this.router.navigate([this.param], { skipLocationChange: true })
        this.toastrService.info(MessageUtil.REGISTRO_NAO_ENCONTRADO);
        return;
      }
      this.destinacaoReservaModel = destinacaoReservaModel;

      this.destinacaoReservaList = [];

      this.destinacaoReservaList.push(
        { descricao: destinacaoReservaModel.dsPagamento, valor: destinacaoReservaModel.vlPagamento });


      if (destinacaoReservaModel.vlImposto !== 0
        || destinacaoReservaModel.vlAdvogado !== 0
        || destinacaoReservaModel.vlDiferenca !== 0) {

        this.destinacaoReservaList.push(
          { descricao: 'Descontos'.toUpperCase(), valor: null });
      }


      if (destinacaoReservaModel.vlAdvogado !== 0) {
        this.destinacaoReservaList.push(
          { descricao: destinacaoReservaModel.dsAdvogado, valor: destinacaoReservaModel.vlAdvogado });
      }
      if (destinacaoReservaModel.vlImposto) {
        this.destinacaoReservaList.push(
          { descricao: destinacaoReservaModel.dsImposto, valor: destinacaoReservaModel.vlImposto });
      }
      if (destinacaoReservaModel.vlDiferenca) {
        this.destinacaoReservaList.push(
          { descricao: destinacaoReservaModel.dsImposto, valor: destinacaoReservaModel.vlImposto });
      }
      this.destinacaoReservaList.push(
        { descricao: destinacaoReservaModel.dsLiquido, valor: destinacaoReservaModel.vlLiquido });

      } catch (error) {
         this.router.navigate([this.param], { skipLocationChange: true })
        this.toastrService.error(MessageUtil.REGISTRO_NAO_ENCONTRADO, '', {timeOut: 8000});
      }
  }


  imprimirPagina() {
    this.dR2009Pdf.funcionarios(
      this.pessoaDadosSimplicadosModel,
      this.descricaoMesAno,
      this.destinacaoReservaModel,
      this.destinacaoReservaList);
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/financeiro/destinacao-reserva/destinacao-reserva-2009/destinacao-reserva-2009.component.ts